import { ReactElement, ReactNode } from 'react';

import classNames from 'classnames';

import { useTranslation } from '@/i18n';

import Button, { ButtonProps } from '../Button';

import styles from './index.module.scss';

export type ButtonConfirmationMessageProps = {
  title?: string;
  text: string | ReactNode;
  onAccept?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  onCancel: (e: React.MouseEvent<HTMLButtonElement>) => void;
  className?: string;
  buttonContainerClassName?: string;
  customButtons?:
    ReactElement<ButtonProps>[] | ((closeMessage: (e: React.MouseEvent<HTMLButtonElement>) => void) => ReactElement<ButtonProps>[]);
};

export default function ButtonConfirmationMessage({
  title,
  text,
  onAccept,
  onCancel,
  className,
  buttonContainerClassName,
  customButtons,
}: ButtonConfirmationMessageProps) {
  const { t } = useTranslation('common');

  const buttons = customButtons instanceof Function ? customButtons(onCancel) : customButtons;

  return (
    <div className={classNames(styles.wrapper, className)}>
      {title && <div className={styles.title}>{title}</div>}
      <div className={styles.text}>{text}</div>

      <div className={classNames(styles.buttonContainer, buttonContainerClassName)}>
        {buttons || (
          <>
            <Button onClick={onAccept} text={t('yes')} />
            <Button onClick={onCancel} text={t('no')} type="secondary" />
          </>
        )}
      </div>
    </div>
  );
}
